<template>
  <div class="pt-4">
    <iframe
      id="issue-iframe"
      width="100%"
      scrolling="false"
      :src="sourceUrl"
      frameborder="0"
      ref="myIframe"
      @load="iframeLoaded"
    ></iframe>
  </div>
</template>

<script>
  import iframeResizer from "iframe-resizer";
  export default {
    name: '',
    data () {
      return {
      }
    },
    created () {
      console.log("Data for iframe", this.data)
    },
    computed: {
      resizeOptions() {
        return {
          log: false,
          scrolling: false,
          heightCalculationMethod: "taggedElement",
        }
      },
      sourceUrl(){
        let url = `/forms/responses/${this.data.form_response_id}?hide_chrome=${this.data.hide_chrome}&hide_form_buttons=${this.data.hide_form_buttons}&from_issue=${this.data.from_issue}&issue_id=${this.data.issue_id}&hide_issues_section=true`
        return url
      }
    },
    methods: {
      resize() {
        const iframes = iframeResizer.iframeResizer(this.resizeOptions, this.$refs.myIframe);
        console.log(this.$refs)
      },
      iframeLoaded(e) {
        this.resize()
      },
    },
    props: {
      data: {
        type: Object,
        required: true,
      },
    },
  }
</script>

<style lang="scss">
</style>
